/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import Countdown from "react-countdown";
import { Card, CardBody, Col, Row } from "reactstrap";
import { H4, H5, Image, LI, UL } from "../../../../AbstractElements";
import { Link } from "react-router-dom";
import { dynamicImage } from "../../../../Utils";

const SpecialDiscountCard = () => {
  const [style, setStyle] = useState({});
  useEffect(() => {
    setTimeout(() => setStyle({ style: { display: "none" } }), 1000);
  }, []);
  const renderer = ({ days, hours, minutes, seconds, completed }: any) => {
    if (completed) return "You are good to go!";
    else {
      return (
        <div className="countdown">
          <UL className="timer-sec simple-list flex-row">
            <LI>
              <span id="days" className="txt-primary days time">{days}</span>
              <span className="title">Days</span>
            </LI>
            <LI>
              <span className="txt-primary hours time" id="hours">{hours}</span>
              <span className="title">Hours</span>
            </LI>
            <LI className="px-3">
              <span className="txt-primary minutes time" id="minutes">{minutes}</span>
              <span className="title">Min</span>
            </LI>
            <LI className="px-3">
              <span className="txt-primary seconds time" id="seconds">{seconds}</span>
              <span className="title">Sec</span>
            </LI>
          </UL>
        </div>
      );
    }
  };
  var d = new Date();
  var year = d.getFullYear();
  var month = d.getMonth();
  var day = d.getDate();
  var countdown = new Date(year, month, day + 15).getTime();
  return (
    <Col xl="4" sm="7" className="xl-40 box-col-5">
      <Card className="special-discount">
        <CardBody>
          <Row>
            <Col xxl="8" xl="12" lg="8" className="offer-order-1 box-col-12">
              <div className="discount-detail">
                <div>
                  <H5>Special Discount <span className="font-primary f-w-500">80%OFF</span></H5>
                  <H4 className="m-auto f-w-600">Deal of the Day from <span className="font-primary">$80</span></H4>
                  <Countdown date={countdown} renderer={renderer} />
                  <Link className="btn btn-primary mt-4" to={`${process.env.PUBLIC_URL}/applications/ecommerce/product`}>View Details</Link>
                </div>
              </div>
            </Col>
            <Col xxl="4" xl="12" lg="4">
              <div className="img-wrapper"><Image className="img-fluid" src={dynamicImage("dashboard-2/shoes.png")} alt="" /></div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SpecialDiscountCard;
